import api from '../index';

const baseUrl = '/repairOrder';
const purchasesBaseUrl = '/purchaseOrder';

export const createJobApi = (data) => {
  return api({
    method: 'post',
    url: `${baseUrl}/createJob`,
    data,
  });
};

export const generateROApi = (data) => {
  return api({
    method: 'post',
    url: 'estimator/create-repair-order',
    data,
  });
};

export const getRepairOrders = (query) => {
  return api({
    method: 'get',
    url: `${baseUrl}/get-all-order-repairs?${query}`,
  });
};

export const getJobCardsApi = () => {
  return api({
    method: 'get',
    url: `${baseUrl}/get-job-cards`,
  });
};

export const getJobCards = (data) => {
  return api({
    method: 'post',
    url: `${baseUrl}/get-job-cards`,
    data,
  });
};
export const getJobCardStatuses = () => {
  return api({
    method: 'get',
    url: `${baseUrl}/get-job-card-statuses`,
  });
};
export const updateJobCardApi = (data) => {
  return api({
    method: 'put',
    url: `${baseUrl}/update-job-card`,
    data: data,
  });
};

export const getRoApi = (id) => {
  return api({
    method: 'get',
    url: `${baseUrl}/get-repair-order-by-id/${id}`,
  });
};

export const getPurchasesApi = (id) => {
  return api({
    method: 'get',
    url: `${purchasesBaseUrl}/get-nexpart-purchases/${id}`,
  });
};

export const getAuthorizationHistoryApi = (roId) => {
  return api({
    method: 'get',
    url: `${baseUrl}/get-authorization-history/${roId}`,
  });
};

export const updateROApi = (data) => {
  return api({
    method: 'put',
    url: `${baseUrl}/update`,
    data,
  });
};

export const getDefaultTerms = (roId, resource, isEstimator = 'false') => {
  return api({
    method: 'get',
    url: `${baseUrl}/get-default-terms?roId=${roId}&resource=${resource}&isEstimator=${isEstimator}`,
  });
};

export const getGeneralInfoApi = (roId) => {
  return api({
    method: 'get',
    url: `${baseUrl}/get-repair-order-general-info/${roId}`,
  });
};

export const updateSidebarDataApi = (data) => {
  return api({
    method: 'put',
    url: `${baseUrl}/update`,
    data: { data: data },
  });
};

export const getEstimatedTotal = (roId) => {
  return api({
    method: 'get',
    url: `${baseUrl}/get-repair-order-estimated-total/${roId}`,
  });
};

export const deleteRoApi = (roId) => {
  return api({
    method: 'delete',
    url: `${baseUrl}/delete-repair-order/${roId}`,
  });
};

export const commentsListApi = (roId) => {
  return api({
    method: 'get',
    url: `${baseUrl}/get-all-comments/${roId}`,
  });
};

export const createCommentApi = (comment) => {
  return api({
    method: 'post',
    url: `${baseUrl}/add-comment`,
    data: comment,
  });
};

export const replyApi = (comment) => {
  return api({
    method: 'post',
    url: `${baseUrl}/add-comment`,
    data: comment,
  });
};

export const updateCommentApi = (comment) => {
  return api({
    method: 'put',
    url: `${baseUrl}/update-comment`,
    data: comment,
  });
};

export const deleteCommentApi = (commentId) => {
  return api({
    method: 'delete',
    url: `${baseUrl}/delete-comment/${commentId}`,
  });
};

export const getMessagesApi = (roId, messageType) => {
  return api({
    method: 'get',
    url: `${baseUrl}/get-all-messages/${roId}/${messageType}`,
  });
};

export const sendMessageApi = (message) => {
  return api({
    method: 'post',
    url: `${baseUrl}/send-message`,
    data: message,
  });
};

export const addMediaAttachmentsApi = (data) => {
  return api({
    method: 'post',
    url: `${baseUrl}/add-media-attachment`,
    data,
  });
};

export const getMediaAttachmentsApi = (roId) => {
  return api({
    method: 'get',
    url: `${baseUrl}/get-media-attachments/${roId}`,
  });
};
export const deleteRoAttachments = (key) => {
  return api({
    method: 'delete',
    url: `${baseUrl}/delete-ro-media-attachments`,
    data: { key },
  });
};

export const shareRoPdfApi = (data) => {
  return api({
    method: 'post',
    url: `${baseUrl}/share-ro-pdf`,
    data,
  });
};

export const getInspectionPdfDataApi = (roId) => {
  return api({
    method: 'get',
    url: `${baseUrl}/get-inspection-pdf-data/${roId}`,
  });
};

export const getCustomerStats = (id) => {
  return api({
    method: 'get',
    url: `${baseUrl}/get-repair-order-customer-stats-by-id/${id}`,
  });
};

export const updateRoStageApi = (data) => {
  return api({
    method: 'post',
    url: `${baseUrl}/update-ro-stage`,
    data,
  });
};

export const negateApi = (data) => {
  return api({
    method: 'post',
    url: `${baseUrl}/negate`,
    data,
  });
};

export const getRoJobStatus = (id) => {
  return api({
    method: 'get',
    url: `${baseUrl}/get-ro-jobs-status/${id}`,
  });
};
export const changeRoJobsStatusToCompleted = (data) => {
  return api({
    method: 'put',
    url: `${baseUrl}/change-ro-jobs-status-to-completed`,
    data,
  });
};
export const closeRoApi = (data) => {
  return api({
    method: 'put',
    url: `${baseUrl}/close-ro`,
    data,
  });
};
export const completeRoApi = (data) => {
  return api({
    method: 'put',
    url: `${baseUrl}/complete-ro`,
    data,
  });
};
export const openRoApi = (roId) => {
  return api({
    method: 'put',
    url: `${baseUrl}/open/${roId}`,
  });
};
export const updateRoTermsApi = (data) => {
  return api({
    method: 'put',
    url: `${baseUrl}/update-ro-terms`,
    data,
  });
};
